// Re-importing this here so we don't have to load application.js in our unit tests
import $ from 'jquery';

export function getBundles(onlyCurrentVersion = false) {
    const results = [];
    let pagination_token = null;

    const execute_query = async PaginationToken => {
        if (PaginationToken) {
            pagination_token = PaginationToken;
        }

        // Issue the request
        return $.ajax({
            url: '/api/device_types/bundle/describe',
            dataType: 'json',
            data: {
                pagination_token: pagination_token,
                only_current_version: onlyCurrentVersion
            }
        }).promise().then(bundle_json => {
            // Gather the results from this query and stash them in the output object
            for (const index in bundle_json.data.bundles) {
                results.push({
                    id: bundle_json.data.bundles[index].id,
                    name: bundle_json.data.bundles[index].name,
                    icon: bundle_json.data.bundles[index].icon,
                    models: bundle_json.data.bundles[index].models
                });
            }

            // Break out of this recursive loop if we've found everything
            if (bundle_json.data.pagination_token == null) {
                // Sort the returned array by the `name` field. This ensures the results
                // are alphabetized
                return results.sort((a, b) => a.name.localeCompare(b.name));
            }

            // If we haven't found everything, recurse again with the updated pagination token
            return execute_query(bundle_json.data.pagination_token);
        }).catch(error => {
            console.error(error);
            throw new Error('Error fetching bundles. Please try again.');
        });
    };

    return execute_query();
}

export function getBundlesForSelect() {
    const results = [];
    let pagination_token = null;

    const execute_query = async PaginationToken => {
        if (PaginationToken) {
            pagination_token = PaginationToken;
        }

        // Issue the request
        return $.ajax({
            url: '/api/device_types/bundle/list',
            dataType: 'json',
            data: {
                pagination_token: pagination_token
            }
        }).promise().then(bundle_json => {
            // Gather the results from this query and stash them in the output object
            for (const index in bundle_json.data.bundles) {
                results.push({
                    id: bundle_json.data.bundles[index].id,
                    name: bundle_json.data.bundles[index].name,
                });
            }

            // Break out of this recursive loop if we've found everything
            if (bundle_json.data.pagination_token == null) {
                // Sort the returned array by the `name` filed. This ensures the results
                // are alphabetized
                return results.sort((a, b) => a.name.localeCompare(b.name));
            }

            // If we haven't found everything, recurse again with the updated pagination token
            return execute_query(bundle_json.data.pagination_token);
        }).catch(error => {
            console.error(error);
            throw new Error('Error fetching bundles. Please try again.');
        });
    };

    return execute_query();
}

export function getBundlesForColumns() {
    const results = [];
    let pagination_token = null;

    const execute_query = async PaginationToken => {
        if (PaginationToken) {
            pagination_token = PaginationToken;
        }

        // Issue the request
        return $.ajax({
            url: '/api/device_types/bundle/describe',
            dataType: 'json',
            data: {
                pagination_token: pagination_token
            }
        }).promise().then(bundle_json => {
            // Gather the results from this query and stash them in the output object
            for (const index in bundle_json.data.bundles) {
                results.push({
                    id: bundle_json.data.bundles[index].id,
                    name: bundle_json.data.bundles[index].name,
                    models: bundle_json.data.bundles[index].models,
                    parts: bundle_json.data.bundles[index].parts
                });
            }

            // Break out of this recursive loop if we've found everything
            if (bundle_json.data.pagination_token == null) {
                return results;
            }

            // If we haven't found everything, recurse again with the updated pagination token
            return execute_query(bundle_json.data.pagination_token);
        }).catch(error => {
            console.error(error);
            throw new Error('Error fetching bundles. Please try again.');
        });
    };

    return execute_query();
}

export function getBundle(id) {
    // Issue the request
    return $.ajax({
        url: '/api/device_types/bundle/describe',
        dataType: 'json',
        data: {
            id: id
        }
    }).promise().then(bundle_json => {
        if (bundle_json.hasOwnProperty('data')) {
            return {
                id: bundle_json.data.bundles[0].id,
                text: bundle_json.data.bundles[0].name,
                name: bundle_json.data.bundles[0].name,
                icon: bundle_json.data.bundles[0].icon,
                models: bundle_json.data.bundles[0].models,
                parts: bundle_json.data.bundles[0].parts
            }
        } else {
            // If this bundle doesn't exist, return null
            return {};
        }
    }).catch(error => {
        console.error(error);
        throw new Error('Error fetching bundles. Please try again.');
    });
}